"use client"
import styled from "@emotion/styled"
import { useLocale, useTranslations } from "next-intl"
import { NewText } from "ui"
import { Apartment } from "utils"
import MiniMap from "../../../ApartmentsForRent/MiniMap"

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const MapContainer = styled.div`
  height: 100%;
`
type Props = {
  apartment: Apartment
}

const ProjectLocation = ({ apartment }: Props) => {
  const locale = useLocale()
  const t = useTranslations("AccordionDetails")
  const address = apartment.address ?? apartment.city

  const fullAddress =
    apartment.address && apartment.city ? `${apartment.address}, ${apartment.city}, ישראל` : address

  return (
    <Container>
      <NewText
        component={"p"}
        desktopFontSize={20}
        desktopLineHeight={"1.2"}
        desktopFontWeight={700}
        mobileFontSize={18}
        mobileFontWeight={700}
        color={"#000"}
        sx={{ margin: 0 }}
      >
        {t("mapLocation")}
      </NewText>
      <MapContainer>
        <MiniMap locale={locale} address={apartment.location} addressStr={fullAddress} newStyle />
      </MapContainer>
    </Container>
  )
}
export default ProjectLocation
